export var ActivationStatus;
(function (ActivationStatus) {
    ActivationStatus["PENDING"] = "PENDING";
    ActivationStatus["ACTIVE"] = "ACTIVE";
})(ActivationStatus || (ActivationStatus = {}));
//# sourceMappingURL=activation.js.map